<template>
  <div class="staff height1">
    <!--      头部      -->
    <bread></bread>
    <!-- <div v-else class="iq-top-navbar">
            <el-page-header @back="goBack" content="下级账号">
            </el-page-header>
        </div> -->
    <!--    内容    -->
    <div class="center-content">
      <div class="iq-card-body">
        <div class="table-top">
          <div class="iq-search-bar">
            <el-form :model="searchForm" :inline="true">
              <el-form-item>
                <el-date-picker v-model="searchForm.datepicker" type="daterange" range-separator="至"
                  start-placeholder="激活时间" end-placeholder="结束日期" value-format="yyyy-MM-dd"
                  :picker-options="pickerOptions0" size="small" style="margin-right: 10px" @change="search">
                </el-date-picker>
              </el-form-item>
              <el-form-item>
                <el-select v-model="searchForm.cardStatus" placeholder="选择卡状态" size="small" style="margin-right: 10px"
                  @change="search">
                  <el-option v-for="item in cardStatusOptions" :key="item.value" :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-select v-model="searchForm.batchId" placeholder="批次" size="small" style="width: 120px" clearable filterable
                  @change="search">
                  <el-option :label="item.id" :value="item.id" v-for="(item, index) in categoryData"
                    :key="index"></el-option>
                </el-select>
              </el-form-item>
              <!-- <el-form-item>
                <el-input v-model="searchForm.batchId" type="text" size="small" placeholder="批次" clearable style="margin-right: 10px" @keyup.enter.native="search"></el-input>
              </el-form-item> -->
              <el-form-item>
                <el-input v-model="searchForm.cardCode" type="text" size="small" placeholder="卡号" clearable
                  @keyup.enter.native="search"></el-input>
              </el-form-item>
              <el-form-item>
                <download-excel v-if="UserData.length > 0" :data="UserData" :fields="json_fields"
                  worksheet="My Worksheet" :header="title" :name="`${title}.xls`" class="excel">
                  <el-button type="warning" size="small" class="el-icon-download">导出当前页数据</el-button>
                </download-excel>
              </el-form-item>
              <el-form-item>
                <download-excel v-if="StaffTotal" :fields="json_fields" :fetch="fetchData" worksheet="My Worksheet"
                  :header="title" :name="`${title}_All.xls`" class="excel">
                  <el-button type="danger" size="small" class="el-icon-download">导出{{ StaffTotal }}条数据</el-button>
                </download-excel>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" size="small" @click="search()">搜索</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
        <el-table :data="UserData" stripe style="width: 100%" ref="multipleTable" height="calc(100% - 90px)"
          :header-cell-style="{ background: '#F5F7FC' }">
          <el-table-column type="index" label="编号" align="center" width="60"></el-table-column>
          <el-table-column prop="cardCode" label="卡号" align="center"> </el-table-column>
          <!-- <el-table-column prop="cardPassword" label="密码" align="center" width="90"> </el-table-column> -->
          <el-table-column prop="memberCardBatchId" label="批次" align="center" width="80"> </el-table-column>
          <el-table-column prop="productName" label="所属产品" align="center"> </el-table-column>
          <el-table-column prop="versionName" label="激活版本" align="center"> </el-table-column>
          <el-table-column prop="useUserName" label="激活会员名" align="center"> </el-table-column>
          <el-table-column prop="useUserPhone" label="会员账号" align="center"> </el-table-column>
          <el-table-column prop="createTime" label="添加时间" align="center" width="160">
            <template slot-scope="scope">
              <p>{{ scope.row.createTime | timefilters }}</p>
            </template>
          </el-table-column>
          <el-table-column prop="useTime" label="激活时间" align="center" width="160">
            <template slot-scope="scope">
              <p>{{ scope.row.useTime | timefilters }}</p>
            </template>
          </el-table-column>
          <!-- <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <span class="primary optionBtn" @click="toDetail(scope.row)">明细</span>
            </template>
          </el-table-column> -->
        </el-table>
        <el-pagination @current-change="ChangePage" :page-size="PageSize" :current-page="PageIndex" :total="StaffTotal"
          layout="total, prev, pager, next, jumper"></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import bread from "../../../components/common/breadcrumb";
import { MemberCard } from "../../../components/HospitalDomain/MemberCard";
export default {
  name: "Staff",
  components: {
    bread,
  },
  data() {
    var memberCard = new MemberCard(this.TokenClient, this.Services.Authorization);
    return {
      MemberCardDomain: memberCard,
      batchId: this.$route.query.id,
      searchForm: {
        statrTime: "",
        endTime: "",
        cardCode: "",
        datepicker: "",
        cardStatus: this.$route.query.id ? -1 : 1,
        batchId: this.$route.query.id || "",
      },
      categoryData: [],
      PageIndex: 1,
      PageTotal: 1,
      PageSize: 15,
      StaffTotal: 0,
      title: '会员卡使用记录',
      json_fields: {
          机构名称: "organizationName",
          会员卡号: {
          field: "cardCode",
          callback: (value) => {
            return "&nbsp;" + value;
          },
        },
        批次: "memberCardBatchId",
        所属产品: "productName",
        激活版本: "versionName",
        激活会员名: "useUserName",
        会员账号: "useUserPhone",
        添加时间: "createTime",
        激活时间: "useTime",
      },
      UserData: [],

      userInfo: JSON.parse(sessionStorage.getItem("userInfo")),
      cardStatusOptions: [
        { label: '全部', value: -1 },
        { label: '待使用', value: 0 },
        { label: '已使用', value: 1 }
      ],
      pickerOptions0: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
    };
  },
  mounted() {
    this.InitialUser();
    this.categorySearch();
  },
  methods: {
    toDetail(item) {
      this.$router.push({
        path: "/Member/MemberUseInfo",
        query: {
          id: item.id,
        },
      });
      //   this.$router.push({
      //     path: '/TestRecord/AnswerUserTest',
      //     query: {
      //       answerPhone: item.answerPhone,
      //     },
      //   })
    },
    ChangePage(pageIndex) {
      this.PageIndex = pageIndex;
      this.InitialUser();
    },
    search() {
      this.PageIndex = 1;
      this.InitialUser();
    },
    categorySearch() {
      var _this = this;
      var item = _this.searchForm;
      _this.MemberCardDomain.GetOrgMemberCardBatchList(
        "",
        "",
       "",
        0,
        1000,
        function (data) {
          _this.categoryData = data.data.results;
        },
        function (error) {
          console.log(error);
        }
      );
    },
    async fetchData() {
      var _this = this
      return await _this.getAllData()
    },
    getAllData() {
      var _this = this;
      return new Promise((resolve, reject) => {
        var item = _this.searchForm;
        if (_this.searchForm.datepicker) {
          item.startTime = _this.searchForm.datepicker[0] + " 00:00:00";
          item.endTime = _this.searchForm.datepicker[1] + " 23:59:59";
        } else {
          item.startTime = "";
          item.endTime = "";
        }
        var statusValue = _this.searchForm.cardStatus;
        var batchValue = _this.searchForm.batchId;
        _this.MemberCardDomain.GetOrgMemberCardDetailList(
          batchValue,
          statusValue,
          _this.searchForm.cardCode,
          "",
          0,
          item.startTime,
          item.endTime,
          _this.PageIndex,
          _this.StaffTotal,
          function (data) {
            resolve(data.data.results);
          },
          function (err) {
            console.log(err)
            resolve('')
          }
        );
      })
    },

    InitialUser() {
      var _this = this;
      var item = _this.searchForm;
      if (_this.searchForm.datepicker) {
        item.startTime = _this.searchForm.datepicker[0] + " 00:00:00";
        item.endTime = _this.searchForm.datepicker[1] + " 23:59:59";
      } else {
        item.startTime = "";
        item.endTime = "";
      }
      var statusValue = _this.searchForm.cardStatus;
      var batchValue = _this.searchForm.batchId;
      _this.MemberCardDomain.GetOrgMemberCardDetailList(
        batchValue,
        statusValue,
        _this.searchForm.cardCode,
        "",
        0,
        item.startTime,
        item.endTime,
        _this.PageIndex,
        _this.PageSize,
        function (data) {
          _this.UserData = data.data.results;

          _this.PageIndex = data.data.pageIndex;
          _this.PageSize = data.data.pageSize;
          _this.PageTotal = data.data.pageCount;
          _this.StaffTotal = data.data.dataTotal;
        },
        function (error) {
          console.log(error);
        }
      );
    },
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>

<style scoped>
.el-page-header {
  line-height: 73px;
  padding-left: 20px;
}
</style>
